// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Calculate/components/CalculateNailsSelection/styles.scss
// module id = 1205
// module chunks = 0